<template>
  <v-container fluid align-start ma-0 pa-2 class="epms6050-main container-height">
    <v-row no-gutters fill-height>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle">
          <template v-slot:body>
            <v-layout column >
              <v-row dense class="form-layout">
                <v-row dense class="form-layout">
                  <v-col cols="2" class="pr-2 pt-1 formHeader">
                    <span>Curent Customer</span>
                  </v-col>
                  <v-col cols="10" class="pl-2 pt-1 form-border-right">
                    <span v-text="currentCustomerText"/>
                  </v-col>
                </v-row>
              </v-row>

              <v-row dense class="form-layout">
                <v-row dense class="form-layout">
                  <v-col cols="2" class="pr-2 pt-1 formHeader">
                    <span> Quotation Receive No:</span>
                  </v-col>
                  <v-col cols="2" class="pl-2 pt-1 form-border-right">
                    <v-text-field
                        v-model="smsNo"
                        dense
                    />
                  </v-col>
                  <v-col>
                    <v-btn size="x-small" variant="tonal" @click="btnSave">
                      Update Information
                    </v-btn>
                  </v-col>
                </v-row>
              </v-row>

              <v-row no-gutters>
                <v-col cols="12" class="pa-0">
                  <DxDataGrid id="epms6050"
                              class="listBox"
                              :ref="epms6050Ref"
                              :data-source="gridMainList"
                              :remote-operations="false"
                              :hover-state-enabled="true"
                              :allow-column-resizing="true"
                              :allow-column-reordering="true"
                              :row-alternation-enabled="true"
                              :show-borders="true"
                              :width="grid.width"
                              :show-row-lines="true"
                              key-expr="rnum"
                              :focused-row-enabled="true"
                              :column-hiding-enabled="false"
                              :selection="{ mode: 'none' }"
                  >
                    <DxEditing :use-icons="true" />
                    <DxColumn data-field="rnum" caption="No" width="3%" data-type="string" alignment="center" :visible="true" :allow-editing="false" />
                    <DxColumn data-field="custCd" caption="Code" width="7%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="custNm" caption="Customer Name" width="15%" data-type="string" alignment="left" :allow-editing="false" />
                    <DxColumn data-field="custNo" caption="Reg. No" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="represent" caption="Represent" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="tel" caption="Quot.Tel" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="dlyNo" caption="Dely.Tel" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="addr" caption="Address" width="35%" data-type="string" alignment="left" :allow-editing="false" />
                    <DxPaging :enabled="true" :page-size="30" />
                  </DxDataGrid>
                </v-col>
              </v-row>

            </v-layout>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {DxColumn, DxDataGrid} from "devextreme-vue/data-grid";
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // 데이타 그리드 사용시 베이스 추가
import ICardVertical from '@/components/common/iCardVertical'
import baseview from '@/components/base/baseview'
import { getNoticeList } from '@/api/view/hip/Z/epmsZ000'
import notify from "devextreme/ui/notify";
import {epms6050, updateSmsInformation} from "@/api/view/hip/I/epms6050";



export default {
  name: 'epms6050',
  mixins: [baseview, BaseDataGrid],
  components: {
    ICardVertical,
    DxDataGrid,
    DxColumn,
  },
  data() {
    return {
      menuTitle: this.$route.meta.title,
      smsNo : '',
      userGrd: this.$store.state.user.userGrd,
      currentCustomerText : '',
      epms6050Ref: 'epms6050Ref',
      gridMainList: [{rnum: 1}],

    }
  },
  computed: {

  },
  methods: {
    init() {
      this.currentCustomerText = '[' + this.$store.state.user.makerCd + '] - ';
      this.currentCustomerText += '['+ this.$store.state.user.makerNm + ']';

      this.doSearchMain();
    },

    async doSearchMain(){
      this.openLoading('searching')
      let params = {
        custCd: this.$store.state.user.makerCd,
      }
      await epms6050(params).then(res => {
        this.gridMainList = res.list
        this.smsNo = res.list[0]['smsNo']
      }).finally(() => {
        this.endLoading()
      })
    },

    async btnSave() {
      let params = {
        custCd: this.$store.state.user.makerCd,
        smsNo: this.smsNo,
      }

      const vm = this
      vm.vToastifyPrompt(
          vm.$t('Do you want to change new sms no.?'),
          'info',
          current => {

            this.openLoading('update information...')
            updateSmsInformation(params)
                .then(res => {
                  this.vToastify(this.$t("Your password is successfully updated."), 'warn')
                  //notify(this.$t('changed'), 'success', 1500)
                  //this.doSearchMain()
                })
                .catch(error => {
                  this.vToastify(this.$t('An error has occured while changing information.'), 'warn')
                  //notify(error, 'error', 1500)
                  this.endLoading()
                })
                .finally(() => {
                  this.endLoading()
                })
          },
          null,
          true
      )
    },
  },
  mounted() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.form-layout .col {
  border-width: 1px 0 1px 1px;
  border-style: solid;
  border-color: gray;


}
.form-border-right {
  border-width: 1px 1px 1px 1px !important;
  border-style: solid !important;
  border-color: gray !important;
}


.formHeader {
  background-color: rgb(223, 227, 213);
  font-weight: bold;
  color: black;
  font-size: 9pt;
}
</style>